import { DeserializableModel } from '@shared/models/deserializable.model';
import { Partner } from '@shared/models/partner.model';
import { Language } from '../interfaces/languages.interface';

export class PartnerServiceItem extends DeserializableModel {
  partner!: Partner;
  title!: string;
  lang!: Language;
  body!: string;
  deserialize(input: PartnerServiceItem, partner: Partner): this {
    Object.assign(this, input);
    this.partner = partner;
    return this;
  }
}
